import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
// import {
//   _add_customer_api,
//   _detail_customer_for_admin_api,
//   _edit_customer_by_admin_api,
// } from "../../DAL/User/User";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Icon } from "@iconify/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { usStates } from "../../utils/constant";
import {
  _detail_customer_for_admin_api,
  update_case_Status,
} from "../../DAL/adminAuth/auth";

const Input = styled("input")({
  display: "none",
});

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const UpdateCases = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { user_id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    contact_number: "",
    password: "",
    confirm_password: "",
    status: "",
    caseCapacity: "",
    caseDetail: "",
    case_type: "",
    caseDetails: "",
    occurrencePeriod: "",
    state: "", // ← string, not array
  });
  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    const postData = {
      case_type: inputs.case_type,
      occurrencePeriod: inputs.occurrencePeriod,
      state: inputs.state,
      caseDetails: inputs.caseDetails, // Detailed description
      // status: inputs.status,
    };

    const result = await update_case_Status(postData, user_id);
    if (result.code === 200) {
      navigate(-1);
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const get_user_detail = async () => {
    setIsEditLoading(true);
    const result = await _detail_customer_for_admin_api(user_id);
    if (result.code === 200) {
      setInputs({
        ...result?.case,
        state: result.case?.state ? capitalize(result.case.state) : "",
      });
      setIsEditLoading(false);
    } else {
      setIsEditLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const EXPERTIES_OPTIONS = [
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "UI/UX Designer",
    "QA Engineer",
    "Project Manager",
  ];
  useEffect(() => {
    if (user_id) {
      get_user_detail();
    }
  }, [user_id]);
  if (isEditLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="d-flex align-items-center">
          <IconButton
            className="back-screen-button "
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
          <div className="page-title-box">
            <h4>{user_id ? "Edit Case" : "Add Case"}</h4>
          </div>
        </div>

        <div className="col-12 col-md-6 mt-3">
          <FormControl fullWidth required>
            <InputLabel id="state-select-label">State</InputLabel>
            <Select
              labelId="state-select-label"
              id="state-select"
              name="state"
              value={inputs.state}
              label="State"
              onChange={handleChange}
              renderValue={(selected) => selected || "Select State"}
            >
              {usStates.map((state) => (
                <MenuItem key={state} value={state}>
                  <Checkbox checked={inputs.state === state} />
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* <div className="col-12 col-md-6 mt-3">
          <FormControl fullWidth required>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="status"
              value={inputs.status}
              label="Status"
              onChange={handleChange}
            >
              <MenuItem value="open">Open</MenuItem>
              <MenuItem value="closed">Closed</MenuItem>
              <MenuItem value="failed">Failed</MenuItem>
            </Select>
          </FormControl>
        </div> */}
        <div className="col-12 col-md-6 mt-1">
          <FormControl fullWidth margin="normal">
            <InputLabel id="source-select-label">Occurance Period</InputLabel>
            <Select
              labelId="source-select-label"
              id="source-select"
              name="occurrencePeriod" // <-- Important
              value={inputs.occurrencePeriod}
              onChange={handleChange}
              label="Occurance Period"
            >
              <MenuItem value="within_30_days">Within past 30 day </MenuItem>
              <MenuItem value="1_to_3_month_ago">1-3 months ago</MenuItem>
              <MenuItem value="3_to_6_month_ago">3-6 months ago</MenuItem>
              <MenuItem value="more_than_6_month_ago">6+ months ago</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="col-12 col-md-6 mt-1">
          <FormControl required fullWidth margin="normal">
            <InputLabel id="occurance-select-label">Case Type</InputLabel>
            <Select
              labelId="occurance-select-label"
              value={inputs.case_type}
              name="case_type" // <-- Important
              onChange={handleChange}
              label="Case Type"
            >
              <MenuItem value="unwanted_spam">
                Unwanted Spam Texts/Calls
              </MenuItem>
              <MenuItem value="scam_recovery">Scam Recovery</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="col-12 col-12 mt-1">
          <TextField
            label="Case Detail"
            name="caseDetails"
            value={inputs.caseDetails}
            onChange={handleChange}
            fullWidth
            margin="normal"
            multiline
            minRows={5}
            variant="outlined"
          />
        </div>

        <div className="d-flex justify-content-end mt-3">
          <Button type="submit" variant="contained" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default UpdateCases;
